import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Mail, RefreshCw, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';
import logo from '../assets/logo-asistelo.png';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const EmailVerificationPending = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [resending, setResending] = useState(false);

  const handleResendEmail = async () => {
    if (!email) {
      toast.error('Email no disponible');
      return;
    }

    try {
      setResending(true);
      await axios.post(`${API_URL}/api/auth/resend-verification`, { email });
      toast.success('Email de verificación reenviado');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al reenviar email');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center shadow-lg border border-slate-200">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src={logo} alt="Asistelo" className="h-12 w-auto" />
        </div>

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-[#2537b0]/10 rounded-full flex items-center justify-center">
            <Mail className="w-10 h-10 text-[#2537b0]" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
          Verifica tu Email
        </h1>

        <p className="text-slate-600 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
          Hemos enviado un email de verificación a:
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6">
          <p className="font-medium text-blue-900" style={{ fontFamily: 'Inter, sans-serif' }}>{email}</p>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-left">
          <p className="text-sm font-semibold text-amber-900 mb-2">
            📬 ¿No recibiste el email?
          </p>
          <ul className="text-sm text-amber-800 space-y-2">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Revisa tu carpeta de spam o correo no deseado</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Verifica que el email sea correcto</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>El enlace expira en <strong>24 horas</strong></span>
            </li>
          </ul>
        </div>

        <div className="space-y-3">
          <Button
            onClick={handleResendEmail}
            disabled={resending || !email}
            variant="outline"
            className="w-full border-[#2537b0] text-[#2537b0] hover:bg-[#2537b0]/5"
          >
            {resending ? (
              <>
                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                Reenviando...
              </>
            ) : (
              <>
                <RefreshCw className="w-4 h-4 mr-2" />
                Reenviar Email
              </>
            )}
          </Button>

          <Button
            onClick={() => navigate('/login')}
            className="w-full bg-[#2537b0] hover:bg-[#1c2a8a]"
          >
            Volver al Login
          </Button>
        </div>

        <div className="mt-6 pt-6 border-t border-slate-200">
          <div className="flex items-center justify-center text-green-600 text-sm mb-2">
            <CheckCircle2 className="w-4 h-4 mr-2" />
            <span style={{ fontFamily: 'Inter, sans-serif' }}>¿Ya verificaste tu email?</span>
          </div>
          <Button
            onClick={() => navigate('/login')}
            variant="link"
            className="text-[#2537b0] hover:underline"
          >
            Iniciar Sesión
          </Button>
        </div>
      </Card>
    </div>
  );
};
